export const replacePlaceholder = (text, placeholder) => {
  let _text = text || '';
  Object.keys(placeholder).forEach((key) => {
    const regex = new RegExp(`{{\\s*${key}\\s*}}`, 'g');
    _text = _text.replace(regex, placeholder[key]);
  });
  return _text;
};
